"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Badge_1 = tslib_1.__importDefault(require("@mui/material/Badge"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const colors_1 = require("@mui/material/colors");
/**
 * An implementation of a badged icon component.
 * The badge is wrapped around an icon, and can also include a tooltip
 *
 * @example ### Badged icon
 *
 * This examples shows a basic badged icon with hover text
 *
 * ```jsx live noInline
 * file://./__examples__/1_BasicIconBadged.jsx
 * ```
 * @category component
 */
const IconBadged = ({ IconComponent, count, tooltipTitle = "", hasError, BadgeProps, TooltipProps, ...restProps }) => {
    const badgeProps = {
        badgeContent: count,
        color: hasError ? "error" : "primary",
        anchorOrigin: {
            vertical: "top",
            horizontal: "right",
        },
        overlap: "rectangular",
        ...BadgeProps,
    };
    const isZero = Number(badgeProps.badgeContent) === 0;
    const Icon = react_1.default.forwardRef((props, ref) => (react_1.default.createElement(IconComponent, { htmlColor: colors_1.grey[600], ...restProps, ...props, ref: ref })));
    return (react_1.default.createElement(Tooltip_1.default, { title: tooltipTitle, ...TooltipProps }, !isZero ? react_1.default.createElement(Badge_1.default, { ...badgeProps }, react_1.default.createElement(Icon, null)) : react_1.default.createElement(Icon, null)));
};
exports.default = IconBadged;
